"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styles_1 = require("@material-ui/core/styles");
const Typography_1 = require("@material-ui/core/Typography");
const classnames_1 = require("classnames");
const Icon_1 = require("../icon/Icon");
const TriangleStyle_1 = require("./jss/TriangleStyle");
const getBorderStyles = (triangleType, triangleSize) => {
    if (triangleType === 'topLeft' || triangleType === 'topLeftNoShadow') {
        return {
            borderTopWidth: triangleSize,
            borderRightWidth: triangleSize
        };
    }
    else if (triangleType === 'topRight') {
        return {
            borderRightWidth: triangleSize,
            borderBottomWidth: triangleSize
        };
    }
    else if (triangleType === 'downLeft') {
        return {
            borderTopWidth: triangleSize,
            borderLeftWidth: triangleSize
        };
    }
    else if (triangleType === 'downRight') {
        return {
            borderBottomWidth: triangleSize,
            borderLeftWidth: triangleSize
        };
    }
};
const CornerIcon = ({ icon, iconSize = 36, iconType = 'material', text, contentColor, triangleType, triangleSize, trianglePosition, triangleBackgroundColor, iconClassName, classes, image }) => {
    const trianglePropsBorder = getBorderStyles(triangleType, triangleSize);
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ style: trianglePosition, className: classes.container }, { children: [(0, jsx_runtime_1.jsx)("div", { style: Object.assign(Object.assign({}, trianglePropsBorder), { borderColor: triangleBackgroundColor }), className: (0, classnames_1.default)({
                    [classes[triangleType]]: true
                }) }), !!text ? ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: classes.textView }, { children: (0, jsx_runtime_1.jsx)(Typography_1.default, Object.assign({ variant: "h6", gutterBottom: true, noWrap: true, style: { color: contentColor }, component: 'span' }, { children: text })) }))) : null, !!icon ? ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, classnames_1.default)(classes.iconView, iconClassName) }, { children: (0, jsx_runtime_1.jsx)(Icon_1.default, { iconType: iconType, iconName: icon, style: { fontSize: iconSize, color: contentColor } }) }))) : null, !!image ? ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, classnames_1.default)(classes.imageView, iconClassName) }, { children: (0, jsx_runtime_1.jsx)("img", { alt: `${image}`, src: image, style: { fontSize: iconSize } }) }))) : null] })));
};
exports.default = (0, styles_1.withStyles)(TriangleStyle_1.default)(CornerIcon);
//# sourceMappingURL=CornerIcon.js.map